var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserLinkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.55.37a14.49 14.49 0 0 0 0 24.26A12.53 12.53 0 0 1 0 12.5 12.5 12.5 0 0 1 15.55.37Z",
    fill: "#FFC801"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.76 8.76s.88-.54 1.62-.82c1.74-.65 4.88-.68 4.88-.68v9.62s-2.82-.4-4.47.23c-.84.32-2.03 1.15-2.03 1.15v-9.5Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.76 8.76s-.89-.54-1.63-.82c-1.74-.65-4.87-.68-4.87-.68v9.62s2.8-.4 4.46.23c.84.32 2.04 1.15 2.04 1.15v-9.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLinkBlue);
export default ForwardRef;